var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconReferral(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "leftmenu/my/icon-referral") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "1.33055874e-13%",
    x2: "50%",
    y2: "104.53891%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222222",
    stopOpacity: 0.7,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222222",
    stopOpacity: 0.995478029,
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222222",
    stopOpacity: 0.995478029,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.8404232,17.4831197 C25.1686136,18.692094 26,20.407265 26,22.3141026 L26,26 L12.3125413,26 L12.3125413,22.3141026 C12.3125413,20.4121795 13.1439277,18.692094 14.4721181,17.4831197 C14.9232973,17.0752137 15.592462,16.9523504 16.1500992,17.217735 C17.057527,17.6502137 18.0764823,17.8959402 19.1562707,17.8959402 C20.2360591,17.8959402 21.2550143,17.6502137 22.1624421,17.217735 C22.7150099,16.9523504 23.389244,17.0702991 23.8404232,17.4831197 Z M6.83755786,13.1681624 C7.74498567,13.600641 8.76394093,13.8463675 9.84372934,13.8463675 C10.6446991,13.8463675 11.4203218,13.7136752 12.1351113,13.4630342 C12.3378885,14.0773504 12.6217765,14.6523504 12.981706,15.1831197 C12.839762,15.2863248 12.6927485,15.3895299 12.5609434,15.5025641 C10.7207406,17.1784188 9.64095217,19.5128205 9.54463302,21.9504274 L3,21.9504274 L3,18.2645299 C3,16.3626068 3.83138638,14.6425214 5.15957681,13.433547 C5.61075601,13.025641 6.27992065,12.9027778 6.83755786,13.1681624 Z M19.1562707,7.04465812 C21.6808464,7.04465812 23.7288957,8.98098291 23.7288957,11.3694444 C23.7288957,13.757906 21.6808464,15.6942308 19.1562707,15.6942308 C16.631695,15.6942308 14.5785762,13.757906 14.5785762,11.3694444 C14.5785762,8.98098291 16.631695,7.04465812 19.1562707,7.04465812 Z M9.83865991,3 C11.9323341,3 13.6964955,4.33183761 14.2389244,6.15021368 C12.7738594,7.40833333 11.8410844,9.21196581 11.800529,11.2269231 C11.2023363,11.4972222 10.5433106,11.6495726 9.83865991,11.6495726 C7.3140842,11.6495726 5.2609654,9.71324786 5.2609654,7.32478632 C5.2609654,4.93632479 7.3140842,3 9.83865991,3 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-17.4%",
    y: "-8.7%",
    width: "134.8%",
    height: "134.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "leftmenu/my/icon-referral",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReferral);
export default __webpack_public_path__ + "static/media/icon-referral.bbcca4532a9d21646ae79453011523dc.svg";
export { ForwardRef as ReactComponent };